export default () => Math.round(performance.now()) / 1000;
